import { SettingsHeading } from '../components/settings/SettingsAppearance';
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MeunSideSetting from "../components/settings/MeunSideSetting";
import { Treasurysettings } from "../components/settings/Treasurysettings";
import { useTranslation } from "react-i18next";
import { Accounts } from "../components/settings/Accounts";
import { TypeOfIncomes } from "../components/settings/TypeOfIncomes";
import { TypeOfexpensess } from "../components/settings/TypeOfexpensess";
import VatPage from "../components/OsVatComponent/VatPage";

const   Settings = () => {
  const [activeMenu, setActiveMenu] = useState("Treasury");
  const [t] = useTranslation("settings");
  const location = useLocation();
  const [loading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const menu = params.get("menu");
    const allowed = new Set([
      "Treasury",
      "account",
      "incomes",
      "expenses",
      "VatSettings",
    ]);
    if (menu && allowed.has(menu)) setActiveMenu(menu);
  }, [location.search]);

  return (
    <>
      <SettingsHeading title={t("general.genralsettings")} />
      <div className="settings-workspace">
        <MeunSideSetting
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
        />
        {!loading && (
          <div className="settings-content">
            {activeMenu === "Treasury" && <Treasurysettings />}
            {activeMenu === "account" && <Accounts />}
            {activeMenu === "incomes" && <TypeOfIncomes />}
            {activeMenu === "expenses" && <TypeOfexpensess />}
            {activeMenu === "VatSettings" && <VatPage />}
          </div>
        )}
      </div>
    </>
  );
};

export default Settings;
